"use client"

import { useContentfulLiveUpdates } from "@contentful/live-preview/react"

import type { TLatestBlogPosts } from "@/ui/components/LatestBlogPostsCarousel"

import type { IndividualBlogPostProps } from "../../_types/insights"
import IndividualBlogPost from "../IndividualBlogPost"

export default function LivePreviewWrapper({
  blogPost,
  latestBlogs,
}: {
  blogPost: IndividualBlogPostProps
  latestBlogs: TLatestBlogPosts
}) {
  const blogPostUpdated = useContentfulLiveUpdates(blogPost)
  const authors = blogPostUpdated?.authorsCollection?.items || []

  return (
    <IndividualBlogPost
      blogPost={blogPostUpdated}
      latestBlogs={latestBlogs}
      authors={authors}
    />
  )
}
